<template>
  <v-main class="p-relative" style="background-color: var(--v-background-base)">
    <alert-container/>
    <login-modal v-if="showLoginModal"/>
    <app-header :class="{'blur-filter': showLoginModal}" @toolbarSideIconClick="handleToolbarSideIconClick"></app-header>
    <v-container :class="{'blur-filter': showLoginModal}" fluid class="pl-0 pr-0 pt-0">
      <v-row justify="center">
        <router-view :key="$route.fullPath"/>
      </v-row>
    </v-container>
  </v-main>
</template>
<script>
import Vue from 'vue'
import AlertContainer from '@/components/header/alert-container/AlertContainer.vue'
import { EventBus } from '@/router/bus'
import { isUserActive, logout, authorizedUserId } from '@/router/auth'
import Header from '@/components/header/Header'
import LoginModal from '@/components/modal/LoginModal.vue'
import securityStore from '@/store/security-store'
import sidebarStore from '@/store/sidebar'

export default {
  components: {
    'app-header': Header,
    'login-modal': LoginModal,
    'alert-container': AlertContainer
  },
  data () {
    return {
      collapsed: sidebarStore.getters.collapsed,
      showOnXs: false
    }
  },
  created () {
    if (!isUserActive()) {
      logout()
      this.$router.push({ name: 'login' })
    }
  },
  methods: {
    longProcessSuccess (params) {
      this.loading = false
      if (params && params.userId && params.userId !== parseInt(authorizedUserId())) { return }
      const processes = Vue.$longProcessConfig.processDefinitions.filter(p => p.id === params.processId)
      var message = this.$t(processes[0].successMessageCode)
      if (processes[0].id === 1 && params.data.appropriationRequestModel && params.data.appropriationRequestModel.status === 1) {
        message = this.$t('appropriations.notValidRequestLoaded')
      }
      EventBus.$emit('alert', {
        variant: 'success',
        message: message,
        errors: []
      })
      if (processes[0].successEvent !== '') {
        EventBus.$emit(processes[0].successEvent, {
          data: params.data
        })
      }
    },
    loadProcessFailed (params) {
      this.loading = false
      if (params && params.userId && params.userId !== parseInt(authorizedUserId())) { return }
      EventBus.$emit('alert', {
        variant: 'error',
        message: this.$t('apiStatusCodes.' + params.error.status.code),
        errors: []
      })
    },
    handleCollapse (collapsed) {
      if (this.$vuetify.breakpoint.xsOnly) {
        this.showOnXs = false
      } else {
        this.collapsed = collapsed
        sidebarStore.dispatch('collapsed', this.collapsed)
      }
    },
    handleToolbarSideIconClick () {
      this.showOnXs = !this.showOnXs
    },
    onResize () {
    }
  },
  computed: {
    showLoginModal () {
      return !securityStore.getters.isAuth
    },
    isHidden () {
      return this.$vuetify.breakpoint.xsOnly && !this.showOnXs
    }
  },
  watch: {
    '$vuetify.breakpoint.xs': function (value) {
      if (value) {
        this.showOnXs = false
      }
    }
  }
}
</script>
